import { createFileRoute, stripSearchParams } from "@tanstack/react-router";

export type SensorStatusSearchParams = {
  postalCode?: string;
  search?: string;
  status?: string;
  batteryLevel?: string;
  cableStatus?: string;
  retired?: boolean;
  mainTab?: string;
};

const defaultValues: SensorStatusSearchParams = {
  search: "",
  postalCode: "",
  status: "",
  batteryLevel: "",
  cableStatus: "",
  retired: false,
  mainTab: "overview",
};

export const Route = createFileRoute("/sensor-status")({
  validateSearch: (
    params: Record<string, unknown>
  ): SensorStatusSearchParams => {
    return {
      search: params["search"]?.toString() ?? "",
      postalCode: params["postalCode"]?.toString() ?? "",
      status: (params["status"] as string) ?? "",
      batteryLevel: (params["batteryLevel"] as string) ?? "",
      cableStatus: (params["cableStatus"] as string) ?? "",
      retired: (params["retired"] as boolean) ?? false,
    };
  },
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
});
